import React from 'react';
import ViolationsSection from '../../../sections/AdminDashboard/Moderation/Violations';

const Violations = () => {
  return <ViolationsSection />;
};

export default Violations;

